/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Bottom_Center_Aria_LabelInputs */

const en_position_bottom_center_aria_label = /** @type {(inputs: Position_Bottom_Center_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bottom center`)
};

const fr_position_bottom_center_aria_label = /** @type {(inputs: Position_Bottom_Center_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En bas au centre`)
};

const de_position_bottom_center_aria_label = /** @type {(inputs: Position_Bottom_Center_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitte unten`)
};

const it_position_bottom_center_aria_label = /** @type {(inputs: Position_Bottom_Center_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In basso al centro`)
};

const ru_position_bottom_center_aria_label = /** @type {(inputs: Position_Bottom_Center_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нижний центр`)
};

const es_position_bottom_center_aria_label = /** @type {(inputs: Position_Bottom_Center_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abajo en el centro`)
};

const zh_cn2_position_bottom_center_aria_label = /** @type {(inputs: Position_Bottom_Center_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`底部中心`)
};

const ja_position_bottom_center_aria_label = /** @type {(inputs: Position_Bottom_Center_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下中央`)
};

const hi_position_bottom_center_aria_label = /** @type {(inputs: Position_Bottom_Center_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निचला बीच का`)
};

const pt_pt2_position_bottom_center_aria_label = /** @type {(inputs: Position_Bottom_Center_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centro inferior`)
};

/**
* | output |
* | --- |
* | "Bottom center" |
*
* @param {Position_Bottom_Center_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_bottom_center_aria_label = /** @type {((inputs?: Position_Bottom_Center_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Bottom_Center_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_bottom_center_aria_label(inputs)
	if (locale === "de") return de_position_bottom_center_aria_label(inputs)
	if (locale === "it") return it_position_bottom_center_aria_label(inputs)
	if (locale === "ru") return ru_position_bottom_center_aria_label(inputs)
	if (locale === "es") return es_position_bottom_center_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_position_bottom_center_aria_label(inputs)
	if (locale === "ja") return ja_position_bottom_center_aria_label(inputs)
	if (locale === "hi") return hi_position_bottom_center_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_position_bottom_center_aria_label(inputs)
	return en_position_bottom_center_aria_label(inputs)
});